/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from "react";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Grid from "@mui/material/Grid2";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormGroup,
  TextField,
  Button,
} from "@mui/material";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageContainer from "../page-container/page-container";
import useEntityTypes from "./use-entity-types";
import LoadingScreen from "../progress/loading-screen";
import WatchListEntities from "./watch-list-entities";
import useWatchListSearch from "./use-watch-list-search";
import { WatchListSearchRequest } from "./types";

const WatchListAdd = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [entityType, setEntityType] = useState<string>("");
  const [iBaseId, setIBaseId] = useState<string>("");
  const [showResults, setShowResults] = useState(false);
  const [searchItems, setSearchItems] = useState<
    WatchListSearchRequest | undefined
  >(undefined);

  const {
    data: searchResults,
    isLoading: searchIsLoading,
    error: searchError,
  } = useWatchListSearch(searchItems);

  const { data: entityTypes, isLoading: entityTypesIsLoading } =
    useEntityTypes();

  const handleEntityChange = async (event: SelectChangeEvent) => {
    setEntityType(event.target.value);
  };

  const onSubmit = async () => {
    setShowResults(true);
    setSearchItems({
      entityTypeId: Number(entityType),
      iBaseId,
    });
  };

  const handleOnTextFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIBaseId(e.target.value);
  };

  if (entityTypesIsLoading) {
    return (
      <LoadingScreen height={400} loadingMessages={["Loading resources..."]} />
    );
  }
  const handleBackClick = () => {
    navigate(`/watch-list?${searchParams}`);
  };

  return (
    <>
      <PageContainer title="Add Watch List">
        <Box
          component="form"
          aria-label="form"
          onSubmit={() => onSubmit()}
          noValidate
          autoComplete="off"
          sx={{
            width: "100%",
          }}
        >
          <FormGroup>
            <Grid container sx={{ width: "100%", pt: 1 }} spacing={2}>
              <Grid size={{ xs: 12, sm: 12, lg: 4 }} sx={{ display: "flex" }}>
                <FormControl sx={{ width: "100%", mb: 2 }} size="small">
                  <TextField
                    id="ibase-id"
                    label="IBase ID"
                    size="small"
                    variant="outlined"
                    value={iBaseId}
                    onChange={handleOnTextFieldChange}
                  />
                </FormControl>
              </Grid>

              <Grid size={{ xs: 12, sm: 12, lg: 4 }} sx={{ display: "flex" }}>
                <FormControl sx={{ width: "100%", mb: 2 }} size="small">
                  <InputLabel id="entity-type-label">Entity Type</InputLabel>
                  <Select
                    labelId="entity-type-label"
                    id="entity-type-select"
                    label="Entity Type"
                    value={entityType}
                    onChange={handleEntityChange}
                  >
                    {entityTypes?.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.description}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid
                size={{ xs: 12, sm: 12, lg: 12 }}
                sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleBackClick}
                  data-testid="search-button"
                  sx={{ textTransform: "none" }}
                >
                  <ArrowBackIosIcon
                    fontSize="small"
                    sx={{ marginRight: 0.5 }}
                  />
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!entityType || !iBaseId || searchIsLoading}
                  onClick={onSubmit}
                  data-testid="search-button"
                  sx={{ textTransform: "none" }}
                >
                  <SearchIcon fontSize="small" sx={{ marginRight: 1 }} />
                  Search
                </Button>
              </Grid>
            </Grid>
          </FormGroup>
        </Box>
      </PageContainer>

      <WatchListEntities
        entities={searchResults}
        isLoading={searchIsLoading}
        showResults={showResults}
        error={searchError}
      />
    </>
  );
};
export default WatchListAdd;
